import { render, staticRenderFns } from "./SkillModal.vue?vue&type=template&id=b137914e&scoped=true"
import script from "./SkillModal.vue?vue&type=script&lang=js"
export * from "./SkillModal.vue?vue&type=script&lang=js"
import style0 from "./SkillModal.vue?vue&type=style&index=0&id=b137914e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b137914e",
  null
  
)

export default component.exports